export * from "./fade.animation";
export * from "./slide-down.animation";
export * from "./slide-left.animation";



// WEBPACK FOOTER //
// ./src/app/shared/animations/index.ts